module.exports = __webpack_public_path__ + "img/2.f26e2d1e.png";